// extracted by mini-css-extract-plugin
export default {"avatarRow":"UserBlockSimple_avatarRow__v0jP7","fio":"UserBlockSimple_fio__vLx5H","role":"UserBlockSimple_role__eCgjP","avatar":"UserBlockSimple_avatar__WRT4+"};